export enum Relationships {
	Self = 'self',
	Child = 'child',
	DomesticPartner = 'domestic partner',
	FosterChild = 'foster child',
	Spouse = 'spouse',
	StepChild = 'step child',
}
